import React, { useState, useEffect  ,useRef} from "react";
import {
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Button,
} from "@mui/material";
import { CircularProgress, Avatar, Box,     } from "@mui/material";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { IoIosPeople } from "react-icons/io";
import { PiStudentBold } from "react-icons/pi";
import { BsPersonCheckFill } from "react-icons/bs";
import { BsFillPersonXFill } from "react-icons/bs";
import { GlobalStyles, maxWidth } from "@mui/system";
import { useAuth } from "../../../AuthProvider";
import { useNavigate } from "react-router-dom";

const ScheduleAndMeetDashboard = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState("today");
  const [isLoading,setIsLoading]=useState(false)
  const [loading, setLoading] = useState(true); // Define loading state
  const [filteredData, setFilteredData] = useState([]); // Define filteredData state
  const {userId,pId,oId ,role,board} = useAuth();


  // const [announcements, setAnnouncements] = useState([]);
  // const [loadingAnnouncements, setLoadingAnnouncements] = useState(true);
  // const [error, setError] = useState(null);
  // const [currentIndex, setCurrentIndex] = useState(0);

  const marqueeRef = useRef(null);
const [announcements, setAnnouncements] = useState({
  exams: [],
  notices: [],
  teachers: [],
  parents: []
});
  
//Announcements api
useEffect(() => {
  const fetchAnnouncements = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/Announcement/getAnnouncement/${oId}/${pId}`);
      if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);

      const data = await response.json();

      const exams = data.examsAnnouncementDto?.map(
        (exam) => `📅 ${exam.examType.replace("_", " ")} Exam on ${exam.examDate} at ${exam.examTime}`
      ) || [];

      const notices = data.noticeAnnouncementsDtos?.map(
        (notice) => `📢 ${notice.title} on ${notice.purposeDate} `
      ) || [];

      const teachers = data.teacherAnnouncementDto?.map(
        (announcement) => `🎓 ${announcement.title} on ${announcement.purposeDate} `
      ) || [];

      const parents = data.parentAnnouncementDto?.map(
        (meeting) => `👨‍👩‍👧 Parent-Teacher Meeting on ${meeting.purposeDate} `
      ) || [];

      // If all categories are empty, show only one ["📢 No announcements available"]
      const hasAnnouncements = exams.length || notices.length || teachers.length || parents.length;
      const defaultMessage = ["📢 No announcements available"];

      setAnnouncements(
        hasAnnouncements
          ? { exams, notices, teachers, parents }
          : { exams: defaultMessage, notices: [], teachers: [], parents: [] }
      );

    } catch (error) {
      console.error("Error fetching announcements:", error);
      setAnnouncements({ exams: ["📢 No announcements available"], notices: [], teachers: [], parents: [] });
    }
  };

  fetchAnnouncements();
}, [baseUrl, oId]);





    //ClassSchedul States
    const [filteredClassData, setFilteredClassData] = useState([]);
    const [loadingClass, setloadingClass] = useState(true);
     const [classsearchQuery, setClasssearchQuery] = useState("");

  //TeachersSchedul States
  const [filteredTeachersData, setFilteredTeachersData] = useState([]);
  const [loadingTeachers, setloadingTeachers] = useState(true);
   const [teacherssearchQuery, setTeacherssearchQuery] = useState("");

  //NOTIFICATION STATES
    const [notifications, setNotifications] = useState([]);
    const [NotificationsearchQuery, setNotificationSearchQuery] = useState("");
    const [loadingNotifications, setLoadingNotifications] = useState(true); // ✅ Define loading state

  //NOTICE BOARD STATES
    const [notices, setNotices] = useState([]);
    const [noticessearchQuery, setNoticeSearchQuery] = useState("");
    const [loadingNotices, setLoadingNotices] = useState(true); // ✅ Define loading state


    //teachers card counts state
    const [teachersCount, setteachersCount] = useState({});


    const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;

  useEffect(() => {
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    fetchUsers();
}, []);


    useEffect(() => {
      // Fetch data from API
      const fetchData = async () => {
        try {
          const today = new Date();
          const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

          const response = await fetch(`${baseUrl}/api/attendance/teachers/count/${formattedDate}/${oId}/${pId}`); // Replace with your API URL
          const data = await response.json();
          setteachersCount(data); // Set the data from API
        } catch (error) {
          console.error("Error fetching data: ", error);
        } 
      };
      fetchData();
    }, []);




    const fetchNotifications = async () => {

       // Check if UserId is available, if not, return early
      const UserId = userId || selectedUsers;
      if (!UserId) return; // ✅ Don't call API if there's no UserId

      setLoadingNotifications(true); // Start loading
      try {

        // const UserId = userId || selectedUsers;
        
        const response = await fetch(`${baseUrl}/api/nonStaffMeeting/getSpecificUserIdMeetings/${UserId}/${oId}`); // Replace with your API URL
        const data = await response.json();
        // ✅ Sort notices by purposeDate (future dates first)
        data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));
        setNotifications(data); // Assuming the response is an array
      } catch (error) {
        console.error("Error fetching notices:", error);
      }finally {
        setLoadingNotifications(false); // Stop loading
      }
    };
  useEffect(() => {
    fetchNotifications();
  }, [userId,selectedUsers]);
  
  
   // Filter notices based on search query
   const filteredNotifications = notifications.filter((notice) => {
    return (
      notice.title.toLowerCase().includes(NotificationsearchQuery.toLowerCase()) || 
      notice.purposeDate.toLowerCase().includes(NotificationsearchQuery.toLowerCase())
    );
  });




  const fetchNotices = async () => {
    setLoadingNotices(true); // Start loading
    try {
      const response = await fetch(`${baseUrl}/api/noticeBoard/getAll/${oId}/${pId}`); // Replace with your API URL
      const data = await response.json();
      // ✅ Sort notices by purposeDate (future dates first)
      data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));

      setNotices(data); // Assuming the response is an array
    } catch (error) {
      console.error("Error fetching notices:", error);
    }finally {
      setLoadingNotices(false); // Stop loading
    }

  };
useEffect(() => {
  fetchNotices();
}, []);


 // Filter notices based on search query
 const filteredNotices = notices.filter((notice) => {
  return (
    notice.title.toLowerCase().includes(noticessearchQuery.toLowerCase()) || 
    notice.purposeDate.toLowerCase().includes(noticessearchQuery.toLowerCase())
    
  );
});



useEffect(() => {
  const fetchClassData = async () => {
    if(!UserId) return;
    setloadingClass(true);
    try {
      const response = await fetch(
        `${baseUrl}/api/classTeacher/getAllClassTeachers/${oId}/${pId}/${UserId}`
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        setFilteredClassData(data); // Set only if data is an array
      } else {
        console.error("Expected an array but got:", data);
        setFilteredClassData([]); // Fallback to an empty array
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      setFilteredClassData([]); // Prevent map error
    } finally {
      setloadingClass(false);
    }
  };
  fetchClassData();
}, [UserId]);

const filteredClassResuts = filteredClassData.filter((row) => {
  if (!classsearchQuery) return true; // Show all if no search input

  const firstName = row.teacherFirstName?.toLowerCase() || "";
  const lastName = row.teacherLastName?.toLowerCase() || "";
  const Class = row.romanNumberClass?.toLowerCase() || "";
  const Section = row.sections?.toLowerCase() || "";
  const query = classsearchQuery.toLowerCase();

  return firstName.includes(query) || lastName.includes(query) || Class.includes(query) || Section.includes(query);
});



useEffect(() => {
  const fetchTeachersData = async () => {
    if(!UserId) return;
    setloadingTeachers(true);
    try {
      const response = await fetch(
        `${baseUrl}/api/teacherTimeTable/getAllTeacherDetails/${oId}/${pId}/${UserId}`
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        setFilteredTeachersData(data); // Set only if data is an array
      } else {
        console.error("Expected an array but got:", data);
        setFilteredTeachersData([]); // Fallback to an empty array
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      setFilteredTeachersData([]); // Prevent map error
    } finally {
      setloadingTeachers(false);
    }
  };
  fetchTeachersData();
}, [UserId]);

const filteredTeacherData = filteredTeachersData.filter((row) => {
  if (!teacherssearchQuery) return true; // Show all if no search input

  const firstName = row.teacherFirstName?.toLowerCase() || "";
  const lastName = row.teacherLastName?.toLowerCase() || "";
  const teacherId = row.teacherId?.toLowerCase() || "";
  const query = teacherssearchQuery.toLowerCase();

  return firstName.includes(query) || lastName.includes(query) || teacherId.includes(query);
});







 
  

  return (
    <div style={{ backgroundColor: "#F5F5F6", minHeight: "100vh", padding: "10px" }}>
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}
      </style>

      

      
      {/* Grid for Teachers and Students Stats */}
      <Grid container spacing={1} style={{ marginTop: "5%" }}>
  {/* Total Teachers */}
  <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #007bff`, minHeight: "50px",cursor:'pointer' }} onClick={() => navigate("/TotalTeachersList")} >
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#cce5ff", // Lighter background color for blue
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IoIosPeople style={{ fontSize: "17px", color: "#007bff" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px" , fontWeight: "bold"}}>TOTAL TEACHERS</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#007bff", fontWeight: "bold" }}>
          {teachersCount.total}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid>


  {/* Present Teachers */}
  <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #28a745`, minHeight: "50px" ,cursor:'pointer'}} onClick={() => navigate("/PresentTeachersList")}>
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#d4edda", // Lighter background color for green
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BsPersonCheckFill style={{ fontSize: "17px", color: "#28a745" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>PRESENT</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#28a745" , fontWeight: "bold"}}>
        {teachersCount.present}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid>


  {/* Absent Teachers */}
  <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #dc3545`, minHeight: "50px" ,cursor:'pointer'}} onClick={() => navigate("/AbsentTeachersList")}>
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#f8d7da", // Lighter background color for red
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BsFillPersonXFill style={{ fontSize: "17px", color: "#dc3545" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>ABSENT</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#dc3545", fontWeight: "bold" }}>
        {teachersCount.absent}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid>

  {/* Total Students */}
  {/* <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #007bff`, minHeight: "50px" }}>
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#cce5ff", // Lighter background color for blue
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <PiStudentBold style={{ fontSize: "17px", color: "#007bff" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px" , fontWeight: "bold"}}>TOTAL STUDENTS</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#007bff", fontWeight: "bold" }}>
          500
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid> */}

  {/* Present Students */}
  {/* <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #28a745`, minHeight: "50px" }}>
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#d4edda", // Lighter background color for green
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
             
            }}
          >
            <BsPersonCheckFill style={{ fontSize: "17px", color: "#28a745" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>PRESENT</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#28a745", fontWeight: "bold" }}>
          450
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid> */}


  {/* Absent Students */}
  {/* <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #dc3545`, minHeight: "50px" }}>
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#f8d7da", // Lighter background color
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              
            }}
          >
            <BsFillPersonXFill style={{ fontSize: "17px", color: "#dc3545" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>ABSENT</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#dc3545", fontWeight: "bold" }}>
          50
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid> */}


</Grid>



<marquee
    ref={marqueeRef} // Attach the ref to the marquee
    behavior="scroll"
    direction="right"
    scrollamount="5"
    onMouseEnter={() => marqueeRef.current && marqueeRef.current.stop()}
    onMouseLeave={() => marqueeRef.current && marqueeRef.current.start()}
    style={{
      marginTop: "13px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "4px 0",
      width: "100%",
      whiteSpace: "nowrap",
    }}
  >
    {[
      ...announcements.exams,
      ...announcements.notices,
      ...announcements.teachers,
      ...announcements.parents,
    ].map((announcement, index) => (
      <span key={index} style={{ marginRight: "20px" }}>
        {announcement}
      </span>
    ))}
  </marquee>




      <div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between" }}>
         {/* Card containing table title, date selector, and table */}
         <Paper
  style={{
    flex: 1.5,
    padding: "5px",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    marginRight: "5px",
  
  }}
>
  <div
    style={{
      // flex: 2,
      marginLeft: "0px",
      paddingLeft: "10px",
      paddingRight: "10px",
      overflow: "auto",
    }}
  >
 <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h5"
                style={{
                  fontWeight: "bold",
                  paddingLeft: "5px", // Added left padding
                  marginTop: "5px",   // Added top margin
                }}
              >
             All Class Schedules
              </Typography>


              <TextField
                label="Search by Class or Section or Name"
                variant="outlined"
                size="small"
                value={classsearchQuery}
                onChange={(e) => setClasssearchQuery(e.target.value)}
                sx={{
                  height: "32px",
                  marginTop:'10px',
                  marginBottom:'10px',
                }}
              />


            </div>

    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        maxHeight: "300px",
        overflow: "auto",
      }}
      className="custom-sidebar-scrollbar"
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
                backgroundColor: "#fff9c4",
                fontWeight:'bold',fontSize:'14px'
              }}
            >
              S.No
            </TableCell>
            {(board === "INTERMEDIATE" ) && (
               <TableCell
               sx={{
                 borderRight: "2px solid #ddd",
                 padding: "4px",
                 textAlign: "center",
                 backgroundColor: "#fff9c4",
                 fontWeight:'bold',fontSize:'14px'
               }}
             >
               Course
             </TableCell>
            )}
            <TableCell
              sx={{
                borderRight: "2px solid #ddd",
                padding: "4px",
                textAlign: "center",
                backgroundColor: "#fff9c4",
                fontWeight:'bold',fontSize:'14px'
              }}
            >
              {board === "INTERMEDIATE" ? "Year" : "Class"}
            </TableCell>
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
                backgroundColor: "#fff9c4",
                fontWeight:'bold',fontSize:'14px'
              }}
            >
              Section
            </TableCell>
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                padding: "4px",
                textAlign: "center",
                backgroundColor: "#fff9c4",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight:'bold',fontSize:'14px'
              }}
            >
              Class Teacher Name
            </TableCell>
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
                backgroundColor: "#fff9c4",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight:'bold',fontSize:'14px'
              }}
            >
              Subject
            </TableCell>
            <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
                backgroundColor: "#fff9c4",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight:'bold',fontSize:'14px'
              }}
            >
              Mobile No
            </TableCell>
            {/* <TableCell
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
                backgroundColor: "#fff9c4",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight:'bold',fontSize:'14px'
              }}
            >
              Email
            </TableCell> */}
            <TableCell sx={{ borderLeft: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>
                  Action
                </TableCell>
            
          </TableRow>
        </TableHead>

        {loadingClass ? (
          <TableBody>
            <TableRow>
            <TableCell
                                        colSpan={9}
                                        style={{ textAlign: "center", padding: "20px" }}
                                      >
                                        <Box
                                          display="flex"
                                          flexDirection="column"
                                          alignItems="center"
                                        >
                                          <CircularProgress />
                                          <Typography variant="body2" sx={{ mt: 1 }}>
                                            Loading Data...
                                          </Typography>
                                        </Box>
                                      </TableCell>
            </TableRow>
          </TableBody>
        ) : filteredClassResuts.length === 0 ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={9} sx={{ textAlign: "center" }}>
                No data found
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            {filteredClassResuts.map((row, index) => (
              <TableRow
                key={row.admissionNumber}
                style={{
                  backgroundColor: "white",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "white"; // Default color
                }}
              >
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    textAlign: "center",
                  }}
                >
                  {index + 1}
                </TableCell>
                {(board === "INTERMEDIATE") &&(
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    textAlign: "center",
                  }}
                >
                {row.course}
                </TableCell>
                )}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    textAlign: "center",
                  }}
                >
                {row.romanNumberClass}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    textAlign: "center",
                  }}
                >
                  {row.sections}
                </TableCell>
                <TableCell
                 sx={{ 
    borderRight: "1px solid #ddd", 
    padding: "4px", 
    textAlign: "center", 
    width: "120px", // Set fixed width
    maxWidth: "120px", // Prevent resizing beyond this width
    whiteSpace: "nowrap", // Prevent text from wrapping
    overflow: "hidden", // Hide overflowing text
    textOverflow: "ellipsis" // Show "..." if text is too long
  }}
                >
                  {`${row.teacherFirstName} ${row.teacherLastName}`}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textAlign: "center",
                  }}
                >
                  {row.subject}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textAlign: "center",
                  }}
                >
                  {row.teacherContactNumber}
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "4px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textAlign: "center",
                  }}
                >
                  {row.teacherEmailId || "N/A"}
                </TableCell> */}
                <TableCell
  sx={{
    borderLeft: "1px solid #ddd",
    padding: "6px",
    // whiteSpace: "nowrap",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    textAlign: "center",
    "&:hover": { backgroundColor: "#f1f1f1" },
  }}
>
<Button
  type="button"
  onClick={() => {
    // if (row?.romanNumberClass && row?.sections && row?.teacherFirstName&& row?.teacherLastName && row?.teacherId) {  // ✅ Use "section" instead of "Section"
      navigate("/ClassTimeTable", {
        state: { 
          selectedClass: row.romanNumberClass, 
          selectedCourseType: row.course,
          selectedSection: row.sections,  // ✅ Corrected from "Section" to "section"
          classTeacherName: `${row.teacherFirstName} ${row.teacherLastName}` , 
          ClassTeacherId: row.teacherId
        },
      });
    // } else {
    //   console.error("Error: Missing class or section data", row);
    // }
  }}
  sx={{
    backgroundColor: "#1976d2",
    color: "white",
    fontSize: "0.75rem",
    padding: "6px 14px",
    height: "30px",
    borderRadius: "20px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    textTransform: "uppercase",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#1565c0",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
    },
  }}
>
  View
</Button>

</TableCell>

               
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  </div>
        </Paper>



{/* notifications  */}
<Box
          sx={{
            padding: "15px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#ffffff",
            width: "380px",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}>
            Notifications
          </Typography>

          {/* Search by Date and Title */}
          <Grid container spacing={2} sx={{ marginBottom: "15px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
  
  {/* Search Field at Left End */}
  <Grid item xs={6}>
    <TextField
      label="Search by Date or Title"
      fullWidth
      size="small"
      value={NotificationsearchQuery}
      onChange={(e) => setNotificationSearchQuery(e.target.value)}
    />
  </Grid>

  {/* Dropdown at Right End */}
  {/* {isPrincipal && (
    <Grid item xs={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
      <FormControl style={{ width: "200px" }} size="small">
        <InputLabel>Select Schedule Admin</InputLabel>
        <Select
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.target.value)}
          label="Select Schedule Admin"
        >
          {users.map((user) => (
            <MenuItem key={user.userId} value={user.userId}>
              {user.userId} - {user.firstName} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  )} */}
</Grid>


          {/* Horizontal Line */}
          <Box sx={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }} />
          <GlobalStyles
                  styles={{
                    '.custom-sidebar-scrollbar': {
                      scrollbarWidth: 'thin', // For Firefox
                      scrollbarColor: 'grey #e0e0e0',
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                      width: '6px', // For WebKit-based browsers
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                      background: '#f1f1f1', // Track color
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                      backgroundColor: 'grey', // Thumb color
                      borderRadius: '10px',
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555',
                    },
                  }}
                />

          {/* Scrollable Container */}
            <Box sx={{ maxHeight: "200px", overflowY: "auto", padding: "10px" }} className="custom-sidebar-scrollbar">
            <Grid container spacing={2}>
              {loadingNotifications ? ( // Show loader when loading
                <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                  <CircularProgress />
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Loading Notifications...
                  </Typography>
                </Box>
               ) : filteredNotifications.length === 0 ? (
                <Typography
                  variant="h6"
                  sx={{ textAlign: "center", color: "#666", width: "100%", padding: "20px", fontStyle: "italic" }}
                >
                  No Notifications available.
                </Typography>
              ) : (
                filteredNotifications.map((data, index) => (
                  <Grid item xs={12} key={index}>
                    <Box
                      sx={{
                        padding: "10px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#D1E9F6",
                        position: "relative",
                        overflow: "hidden",
                        marginTop: "10px",
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                          backgroundColor: "#b3d8ec",
                        },
                      }}
                    >
                      {/* "New!" Ribbon Badge */}
                     {(() => {
  if (!data.time || !data.purposeDate) return null; // ✅ SAFETY CHECK

  const currentTime = new Date();

  const [timeString, period] = data.time.split(" ");
  const [hours, minutes] = timeString.split(":").map(Number);

  let adjustedHours = hours;
  if (period === "PM" && hours !== 12) adjustedHours += 12;
  if (period === "AM" && hours === 12) adjustedHours = 0;

  const noticeDateTime = new Date(data.purposeDate);
  noticeDateTime.setHours(adjustedHours, minutes, 0, 0);

  const isNew = currentTime < noticeDateTime;

  return isNew ? (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        backgroundColor: "blue",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "0.75rem",
        padding: "6px 12px",
        borderTopRightRadius: "8px",
        borderBottomLeftRadius: "8px",
      }}
    >
      New!
    </Box>
  ) : null;
})()}

          
          
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {/* Date Box */}
                        <Box
                          sx={{
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            borderRadius: "8px",
                            padding: "10px",
                            fontSize: "0.9rem",
                            fontWeight: "bold",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            "&:hover": {
                              backgroundColor: "#388E3C",
                              transform: "scale(1.05)",
                            },
                          }}
                        >
                          {data.purposeDate}
                        </Box>
                      </div>
          
                  
                        {/* Title in single row */}
                      <Box sx={{ marginTop: "10px", display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#444" }}
                        >
                          Title:
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{ fontWeight: "bold", color: "#333" }}
                        >
                          {data.title}
                        </Typography>
                      </Box>
          
                      {/* Description */}
                      {/* <Typography variant="body2" sx={{ marginTop: "5px", color: "#666", fontWeight: "bold" }}>
                        {data.meetingPurpose}
                      </Typography> */}
                      <Box sx={{ marginTop: "10px", display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#444" }}
                        >
                          Purpose:
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{ color: "#666" }}
                        >
                          {data.meetingPurpose}
                        </Typography>
                      </Box>
          
                      {/* Created By */}
                      {/* <Typography variant="body2" sx={{ marginTop: "5px", fontStyle: "italic", color: "#444" }}>
                        Time: <span>{data.time || "N/A"}</span>
                      </Typography> */}
                    </Box>
                  </Grid>
                ))
              )}
            </Grid>
          </Box>



        </Box>




      </div>


{/* Teacher Schedule */}

<Grid container spacing={1} sx={{ marginTop: "10px" }}>

    {/* Left Side - Teacher Schedules */}
    <Grid item xs={12} md={7}>
        <Paper
          style={{
            flex: 2,
            padding: "5px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            marginRight: "5px",
          }}
        >
          <div
            style={{
              flex: 2,
              marginLeft: "0px",
              paddingLeft: "10px",
              paddingRight: "10px",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h5"
                style={{
                  fontWeight: "bold",
                  paddingLeft: "5px", // Added left padding
                  marginTop: "5px",   // Added top margin
                }}
              >
              Teacher Schedules
              </Typography>


              <TextField
                label="Search by Name or Id"
                variant="outlined"
                size="small"
                value={teacherssearchQuery}
                onChange={(e) => setTeacherssearchQuery(e.target.value)}
                sx={{
                  height: "32px",
                  marginTop:'10px',
                  marginBottom:'10px',
                }}
              />


            </div>

            <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            maxHeight: "270px",
            overflow: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px'}}>
                  S.No
                </TableCell>
                <TableCell 
  sx={{ 
    borderRight: "1px solid #ddd", 
    padding: "4px", 
    textAlign: "center", 
    backgroundColor: "#fff9c4",
    width: "120px", // Set fixed width
    maxWidth: "120px", // Prevent resizing beyond this width
    whiteSpace: "nowrap", // Prevent text from wrapping
    overflow: "hidden", // Hide overflowing text
    textOverflow: "ellipsis", // Show "..." if text is too long
    fontWeight:'bold',fontSize:'14px'
  }}
>
  Tech Id
</TableCell>

                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" }}>
                  Teacher Name
                </TableCell> */}
                <TableCell 
  sx={{ 
    borderRight: "1px solid #ddd", 
    padding: "4px", 
    textAlign: "center", 
    backgroundColor: "#fff9c4",
    width: "120px", // Set fixed width
    maxWidth: "120px", // Prevent resizing beyond this width
    whiteSpace: "nowrap", // Prevent text from wrapping
    overflow: "hidden", // Hide overflowing text
    textOverflow: "ellipsis", // Show "..." if text is too long
    fontWeight:'bold',fontSize:'14px'
  }}
>
Teacher Name
</TableCell>
                
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", whiteSpace: "nowrap", backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'bold',fontSize:'14px'}}>
                  Subject
                </TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>
                  Mobile No
                </TableCell> */}
                          <TableCell 
  sx={{ 
    borderRight: "1px solid #ddd", 
    padding: "4px", 
    textAlign: "center", 
    backgroundColor: "#fff9c4",
    width: "120px", // Set fixed width
    maxWidth: "120px", // Prevent resizing beyond this width
    whiteSpace: "nowrap", // Prevent text from wrapping
    overflow: "hidden", // Hide overflowing text
    textOverflow: "ellipsis", // Show "..." if text is too long
    fontWeight:'bold',fontSize:'14px'
  }}
>
Mobile No
</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>
                  Email
                </TableCell> */}
                <TableCell sx={{ borderLeft: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            {loadingTeachers ? (
              <TableBody>
                <TableRow>
                   <TableCell
                                        colSpan={7}
                                        style={{ textAlign: "center", padding: "20px" }}
                                      >
                                        <Box
                                          display="flex"
                                          flexDirection="column"
                                          alignItems="center"
                                        >
                                          <CircularProgress />
                                          <Typography variant="body2" sx={{ mt: 1 }}>
                                            Loading Data...
                                          </Typography>
                                        </Box>
                                      </TableCell>
                </TableRow>
              </TableBody>
            ) : filteredTeacherData.length === 0 ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={7} sx={{ textAlign: "center" }}>
                    No data found
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {filteredTeacherData.map((row, index) => (
                  <TableRow
                    key={row.teacherId}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white"; // Default color
                    }}
                  >
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
                      {index + 1}
                    </TableCell>
                    {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center",width:'40px' }}>
                      {row.teacherId}
                    </TableCell> */}
                    <TableCell 
  sx={{ 
    borderRight: "1px solid #ddd", 
    padding: "4px", 
    textAlign: "center", 
    width: "120px", // Set fixed width
    maxWidth: "120px", // Prevent resizing beyond this width
    whiteSpace: "nowrap", // Prevent text from wrapping
    overflow: "hidden", // Hide overflowing text
    textOverflow: "ellipsis" // Show "..." if text is too long
  }}
>
{row.teacherId}
</TableCell>

                    {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {row.teacherFirstName} {row.teacherLastName}
                    </TableCell> */}
                               <TableCell 
  sx={{ 
    borderRight: "1px solid #ddd", 
    padding: "4px", 
    textAlign: "center", 
    width: "120px", // Set fixed width
    maxWidth: "120px", // Prevent resizing beyond this width
    whiteSpace: "nowrap", // Prevent text from wrapping
    overflow: "hidden", // Hide overflowing text
    textOverflow: "ellipsis" // Show "..." if text is too long
  }}
>
{row.teacherFirstName} {row.teacherLastName}
</TableCell>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {Array.isArray(row.subject)
                          ? row.subject.join(", ")
                          : row.subject}
                    </TableCell>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
                    {row.teacherContactNumber}
                    </TableCell>
                    {/* <TableCell sx={{ padding: "4px", textAlign: "center" }}>
                    {row.teacherEmailId || "N/A"}
                    </TableCell> */}
                    <TableCell
                                            sx={{
                                              borderLeft: "1px solid #ddd",
                                              padding: "6px", // Slightly more padding for better spacing
                                              // whiteSpace: "nowrap",
                                              // overflow: "hidden",
                                              // textOverflow: "ellipsis",
                                              textAlign: "center",
                                              // Light background to differentiate
                                              "&:hover": {
                                                backgroundColor: "#f1f1f1", // Slight hover effect on the cell
                                              },
                                            }}
                                          >
                                            <Button
                                              type="button"
                                              onClick={() =>
                                                navigate(`/TeacherTimeTable`, {
                                                  state: { student: row },
                                                })
                                              }
                                              sx={{
                                                backgroundColor: "#1976d2",
                                                color: "white",
                                                fontSize: "0.65rem", // Slightly increased font size for better readability
                                                padding: "4px 12px", // Adjusted padding for better button size
                                                height: "28px", // Slightly increased height for comfort
                                                borderRadius: "20px", // Rounded button
                                                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // Adds subtle shadow
                                                textTransform: "uppercase", // Capitalizes button text for emphasis
                                                transition: "all 0.3s ease", // Smooth transition for hover effects
                                                "&:hover": {
                                                  backgroundColor: "#1565c0", // Darker shade on hover
                                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)", // More shadow on hover
                                                },
                                              }}
                                            >
                                             View
                                            </Button>
                                          </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>

          </div>
                </Paper>
                </Grid>

 {/* Right Side - Notice Board */}
        <Grid item xs={12} md={5}>
      
          {/* Scrollable Container */}
          <Box
          sx={{
            padding: "15px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#ffffff",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}>
            Notice Board 
          </Typography>

          {/* Search by Date and Title */}
          <Grid container spacing={2} sx={{ marginBottom: "15px" }}>
            <Grid item xs={12} sm={6}>
            <TextField
            label="Search by Date or Title"
            fullWidth
            size="small"
            value={noticessearchQuery}
            onChange={(e) => setNoticeSearchQuery(e.target.value)}
          />
            </Grid>
          </Grid>

          {/* Horizontal Line */}
          <Box sx={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }} />
          <GlobalStyles
                  styles={{
                    '.custom-sidebar-scrollbar': {
                      scrollbarWidth: 'thin', // For Firefox
                      scrollbarColor: 'grey #e0e0e0',
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                      width: '6px', // For WebKit-based browsers
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                      background: '#f1f1f1', // Track color
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                      backgroundColor: 'grey', // Thumb color
                      borderRadius: '10px',
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555',
                    },
                  }}
                />

          {/* Scrollable Container */}
           <Box sx={{ maxHeight: "200px", overflowY: "auto", padding: "10px" }} className="custom-sidebar-scrollbar">
                <Grid container spacing={2}>
          
                  {loadingNotices ? ( // Show loader when loading
                        <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Notices...
                          </Typography>
                        </Box>
                       ) : filteredNotices.length === 0 ? (
                    <Typography
                      variant="h6"
                      sx={{ textAlign: "center", color: "#666", width: "100%", padding: "20px", fontStyle: "italic" }}
                    >
                      No notices available.
                    </Typography>
                  ) : (
                    filteredNotices.map((data, index) => (
                      <Grid item xs={12} key={index}>
                          <Box
                           
                            sx={{
                              padding: "10px",
                              borderRadius: "10px",
                              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "#D1E9F6",
                              position: "relative",
                              overflow: "hidden",
                              marginTop: "10px",
                              transition: "all 0.2s ease-in-out",
                              "&:hover": {
                                backgroundColor: "#b3d8ec",
                              },
                            }}
                          >
                            {/* "New!" Ribbon Badge - Properly Aligned */}
                            {new Date() - new Date(data.purposeDate) < 24 * 60 * 60 * 1000 && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "0",
                                  right: "0",
                                  backgroundColor: "blue",
                                  color: "#fff",
                                  fontWeight: "bold",
                                  fontSize: "0.75rem",
                                  padding: "6px 12px",
                                  textTransform: "uppercase",
                                  borderTopRightRadius: "8px",
                                  borderBottomLeftRadius: "8px",
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                }}
                              >
                                New!
                              </Box>
                            )}
          
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {/* Date Box */}
                              <Box
                                sx={{
                                  backgroundColor: "#4CAF50",
                                  color: "#fff",
                                  borderRadius: "8px",
                                  padding: "10px",
                                  fontSize: "0.9rem",
                                  fontWeight: "bold",
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                  "&:hover": {
                                    backgroundColor: "#388E3C",
                                    transform: "scale(1.05)",
                                  },
                                }}
                              >
                                {data.purposeDate}
                              </Box>
          
                             
                            </div>
          
                            {/* Title */}
                            {/* <Typography
                              variant="h5"
                              sx={{ fontWeight: "bold", color: "#333", marginTop: "10px" }}
                            >
                              {data.title}
                            </Typography> */}
                             <Box sx={{ marginTop: "10px", display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#444" }}
                        >
                          Notice:
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{ fontWeight: "bold", color: "#333" }}
                        >
                          {data.title}
                        </Typography>
                      </Box>
          
                            {/* Description */}
                            {/* <Typography
                              variant="body2"
                              sx={{ marginTop: "5px", color: "#666", fontWeight: "bold" }}
                            >
                              {data.description}
                            </Typography> */}
                             <Box sx={{ marginTop: "10px", display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#444" }}
                        >
                          Notice Purpose:
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#666" }}
                        >
                          {data.description}
                        </Typography>
                      </Box>
          
                            {/* Created By */}
                            <Typography
                              variant="body2"
                              sx={{ marginTop: "5px", fontStyle: "italic", color: "#444" }}
                            >
                              Sent By: {data.nameOfCreatedByNotice}
                               {/* Time:{" "} */}
                              {/* <span>{data.time}</span> */}
                            </Typography>
                          </Box>
          
                      </Grid>
                    ))
                  )}
                </Grid>
              </Box>


        </Box>




                  </Grid>
</Grid>


    </div>
  );
};



const cardStyle = {
  padding: "10px",
  position: "relative",
  borderRadius: "8px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  height: "40px",
};




export default ScheduleAndMeetDashboard;